/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import { Box, Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
// import * as Sentry from "@sentry/react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import AutoCompleteDropdown from "../../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
// import DateRangePicker from "../../../components/Layout/DateRangePicker/DateRangePicker";
// import DropDownSelect from "../../../components/Layout/Dropdown";
// import Dropdown from "../../../components/common/new/Dropdown/Dropdown";
// import SwitchButton from "../../../components/common/SwitchButton";
// import useQueryParams from "../../../hooks/useQueryParams";
// import useParamsQuery from "../Components/hooks/useParamsQuery";
// import { SET_POSITIONS } from "../../../redux/actionTypes/meta";
// import IntroductionForm from "../../../services/api/introductionForm";
// import { isEmptyObj } from "../Components/helper";
// import styles from "./SearchForm/SearchForm.styles";
// import { MAINLINE_POSITION_KEY, POSITIONS_KEY } from "./utils";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import styled from "styled-components";
// import Radio from "@mui/material/Radio";
// import RadioGroup from "@mui/material/RadioGroup";
import { SERVICES } from "../../../../components/Layout/Services";
import { get } from "../../../../components/Layout/ApiHandler/apihandler";

// const MAINLINE_POSITION = "MAINLINE_POSITION";
// const DEPUTY_POSITION = "DEPUTY_POSITION";
// const Text = styled.p`
//   color: #484848;
//   font-size: 16px;
//   font-weight: 600;
//   margin: 0 0;
// `;

// const initialFormValue = {
//   dateOfBirthFrom: "",
//   dateOfBirthTo: "",
//   dateOfJoiningFrom: "",
//   dateOfJoiningTo: "",
//   appointedAtFrom: "",
//   appointedAtTo: "",
//   conferralDateFrom: "",
//   conferralDateTo: "",
// };
const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));
function AdvancedSearch({
  updatePayableCity,
  updatePaymentMethod,
  updateReportType,
  updateSortingMethod,
}) {
  // const [isGohonzonMember, setIsGohonzonMember] = useState(false);
  // const [isOmamoriGohonzonMember, setIsOmamoriGohonzonMember] = useState(false);
  // const [unsubscribe, setUnsubscribe] = useState(false);
  //   const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
  //     useState(initialFormValue);
  //   const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  //   const [positions, setPositions] = useState([]);
  //   const [mainlinePositions, setMainlinePositions] = useState([]);
  //   const [selectedPositions, setSelectedPositions] = useState([]);
  //   const [selectedMainlinePositions, setSelectedMainlinePositions] = useState(
  //     []
  //   );
  //   const [selectedGohonzonTypes, setSelectedGohonzonTypes] = useState([]);
  //   const gohonzonTypeOptions = [
  //     { entityTitle: "Okataki gohonzon", value: "OKATAKI_GOHONZON" },
  //     { entityTitle: "Omamori gohonzon", value: "OMAMORI_GOHONZON" },
  //   ];
  //   const [banks, setBanks] = useState([]);
  const [payableCity, setPayableCity] = useState([]);
  // const [selectedProfession, setSelectedProfession] = useState("");
  //   const [selectedDepositBank, setSelectedDepositBank] = useState("");
  const [selectedPayableCity, setSelectedPayableCity] = useState("");
  const paymentMethods = ["CHEQUE", "DEMAND_DRAFT"];
  const reportType = ["List Of Cheque/DDs", "Cheque Deposit List"];
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [selectedReportType, setSelectedreportType] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sortFields = [
    { value: "fullName", label: "Name" },
    { value: "orderId", label: "Order ID" },
    { value: "updatedAt", label: "Contribution Date" },
  ];

  const sortOrders = [
    { value: "ASC", label: "Ascending" },
    { value: "DESC", label: "Descending" },
  ];

  const [selectedSortField, setSelectedSortField] = useState("");
  const [selectedSortOrder, setSelectedSortOrder] = useState("");
  const [profileData, setProfileData] = useState({});
  //   const dispatch = useDispatch();
  //   const handleBanks = async() => {
  //     try{
  //       const url = `${SERVICES.BANKS_DETAILS}`;
  //       const response = await get(url);
  //       if(response.ok){
  //         const data = await response.json();
  //         // console.log(data);
  //         setBanks(data.data.content)
  //       }
  //     }
  //     catch(error){
  //       console.error("Error", error);
  //     }
  //   }
  const handlePayableCity = async () => {
    try {
      const url = `${SERVICES.PAYABLE_CITY}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setPayableCity(data?.data?.content);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  //   useEffect(() => {
  //     const queryObject = getQueryObject();
  //     if (!isEmptyObj(queryObject)) {
  //       const query = getQueryParams(queryObject)[0];
  //       Object.keys(initialFormValue).forEach((key) => {
  //         setInitialAdvanceFormValue((prev) => ({
  //           ...prev,
  //           [key]: query[key] ?? "",
  //         }));
  //       });

  //       // positions
  //       [POSITIONS_KEY, MAINLINE_POSITION_KEY].forEach((key) => {
  //         if (query[key]) {
  //           const positionsInNumber = query[key].split(",").map(Number);
  //           if (key === POSITIONS_KEY) setSelectedPositions(positionsInNumber);
  //           else setSelectedMainlinePositions(positionsInNumber);
  //         } else if (key === POSITIONS_KEY) setSelectedPositions([]);
  //         else setSelectedMainlinePositions([]);
  //       });
  //     } else {
  //       setInitialAdvanceFormValue(initialFormValue);
  //       setSelectedPositions([]);
  //       setSelectedMainlinePositions([]);
  //     }
  //   }, [urlSearchParams.toString()]);
  // console.log(selectedPayableCity);
  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  useEffect(() => {
    getUserRole();
  }, []);
  useEffect(() => {
    // handleBanks();
    handlePayableCity();
    updatePayableCity(selectedPayableCity);
    updatePaymentMethod(selectedPaymentMethod);
    updateReportType(selectedReportType);
  }, [selectedPayableCity, selectedPaymentMethod, selectedReportType]);
  useEffect(() => {
    const sortOrder = selectedSortOrder || "ASC";
    const sortField = selectedSortField || "fullName";
    updateSortingMethod(`${sortField},${sortOrder}`);
  }, [selectedSortField, selectedSortOrder]);
  useEffect(() => {
    if (queryParams.get("payableCity") === null) {
      setSelectedPayableCity("");
    }
    if (queryParams.get("orderPaymentMethod") === null) {
      setSelectedPaymentMethod("");
    }
  }, [queryParams.get("payableCity"), queryParams.get("orderPaymentMethod")]);
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      {(profileData?.assignedRoles?.includes("contributionAdmin") ||
        profileData?.assignedRoles?.includes("contributionDataEntry")) && (
        <Grid item xs={6}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.cityName}
            options={getOptions(payableCity, "cityName")}
            label="Payable City"
            name="payableCity"
            value={selectedPayableCity}
            onChange={(selectedValue) => {
              setSelectedPayableCity(selectedValue?.value);
            }}
            inputProps={{ required: false }}
            useHiddenInput
          />
        </Grid>
      )}
      {(profileData?.assignedRoles?.includes("contributionAdmin") ||
        profileData?.assignedRoles?.includes("contributionDataEntry")) && (
        <Grid item xs={6}>
          <AutoCompleteDropdown
            options={paymentMethods.map((method) => ({
              value: method,
              label: method,
            }))}
            label="Payment Method"
            name="paymentMethod"
            value={selectedPaymentMethod}
            onChange={(selectedValue) => {
              setSelectedPaymentMethod(selectedValue?.value);
            }}
            inputProps={{ required: false }}
            useHiddenInput
          />
        </Grid>
      )}
      <Grid item xs={6}>
        <AutoCompleteDropdown
          options={reportType.map((method) => ({
            value: method,
            label: method,
          }))}
          label="Report Type"
          name="reportType"
          value={
            profileData?.assignedRoles?.includes("contributionOfflineDataEntry")
              ? "Cheque Deposit List"
              : selectedReportType
          }
          onChange={(selectedValue) => {
            setSelectedreportType(selectedValue?.value);
          }}
          inputProps={{ required: false }}
          useHiddenInput
          disabled={profileData?.assignedRoles?.includes(
            "contributionOfflineDataEntry",
          )}
        />
      </Grid>
      {(profileData?.assignedRoles?.includes("contributionAdmin") ||
        profileData?.assignedRoles?.includes("contributionDataEntry")) && (
        <Grid item xs={6}>
          <AutoCompleteDropdown
            options={sortFields.map((field) => ({
              value: field.value,
              label: field.label,
            }))}
            label="Sort Field"
            value={selectedSortField}
            onChange={(selectedValue) => {
              setSelectedSortField(selectedValue?.value);
            }}
            inputProps={{ required: false }}
            useHiddenInput
          />
        </Grid>
      )}
      {(profileData?.assignedRoles?.includes("contributionAdmin") ||
        profileData?.assignedRoles?.includes("contributionDataEntry")) && (
        <Grid item xs={6}>
          <AutoCompleteDropdown
            options={sortOrders.map((order) => ({
              value: order.value,
              label: order.label,
            }))}
            label="Sort Order"
            value={selectedSortOrder}
            onChange={(selectedValue) => {
              setSelectedSortOrder(selectedValue?.value);
            }}
            inputProps={{ required: false }}
            useHiddenInput
          />
        </Grid>
      )}
    </Box>
  );
}

export default AdvancedSearch;
